import { Field, Form, Formik, FormikHelpers } from 'formik';
import FormInput from '../shared/forms/input';
import Button from '../shared/buttons/button';
import { useCreateTempUserMutation } from '../../hooks/react-query/use-temp-user';
import { CreateTempUserDataType } from '../../api/temp-user';
import { useState } from 'react';
import MahakModal, { AUTH_STATE } from './modals/modal';
import { useCreateOrderMutation } from '../../hooks/react-query/use-order';
import { randomString } from '../../utils/random';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import Alert from '../shared/alert';
import { useUser } from '../../hooks/react-query/use-user';
import { mobile } from '../shared/forms/validations';
import Loader from '../shared/loader';
import { APIErrorType } from '../../api';

export type MahakFormData = CreateTempUserDataType;
export type MahakFormPropsType = {
  formId?: string;
};

function MahakForm({ formId = randomString(5) }: MahakFormPropsType) {
  const [showModal, setShowModal] = useState(false);
  const [modalState, setModalState] = useState<AUTH_STATE>('DONE');
  const { mutate: createTempUser } = useCreateTempUserMutation();
  const { mutateAsync: createOrder } = useCreateOrderMutation();
  const { formErrorMessage, setFormError, resetFormErrorMessage } = useFormErrorMessage();
  const { data: user, isLoading: userIsLoading, isAuthenticated } = useUser();

  async function submit(values: MahakFormData, { setErrors }: FormikHelpers<MahakFormData>) {
    resetFormErrorMessage();
    if (isAuthenticated) {
      await createMahakOrder();
    } else {
      createTempUser(values, {
        onSuccess: () => {
          setModalState('REGISTER');
          setShowModal(true);
        },
        onError: error => {
          if (
            error.status === 400 &&
            error.data[0] === 'کاربری با این شماره تلفن همراه وجود دارد.'
          ) {
            setModalState('LOGIN');
            setShowModal(true);
          } else {
            setErrors({ mobile: error.data });
          }
        }
      });
    }
  }

  const createMahakOrder = async () => {
    const mahakPackageId = 300;
    try {
      await createOrder({ packages: [mahakPackageId] });
      setModalState('DONE');
      setShowModal(true);
    } catch (error) {
      setShowModal(false);
      setFormError(error as APIErrorType);
    }
  };

  if (userIsLoading) return <Loader full={false} />;

  return (
    <Formik initialValues={{ mobile: user?.mobile || '' }} onSubmit={submit}>
      {({ values, dirty, isSubmitting }) => (
        <>
          <Form noValidate className='grid grid-cols-1 gap-2 py-3'>
            {formErrorMessage && <Alert content={formErrorMessage} className='my-2' />}
            {!isAuthenticated && (
              <Field
                required
                noLabel
                id={`${formId}_mobile`}
                name='mobile'
                placeholder='شماره تلفن همراه'
                component={FormInput}
                type='tel'
                maxLength={11}
                validate={mobile}
              />
            )}
            <Button
              type='submit'
              color='green'
              content='شرکت میکنم و تخفیف میگیرم'
              disabled={!dirty && isSubmitting}
              className='2xs:text-lg'
            />
          </Form>
          <MahakModal
            state={modalState}
            showModal={showModal}
            mobile={values.mobile}
            onSuccess={createMahakOrder}
            onClose={() => setShowModal(false)}
          />
        </>
      )}
    </Formik>
  );
}

export default MahakForm;
